import { render, staticRenderFns } from "./ClosedDayDetail.vue?vue&type=template&id=52724961"
import script from "./ClosedDayDetail.vue?vue&type=script&lang=ts"
export * from "./ClosedDayDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports